import React from 'react'

import './App.css'
import { Toaster } from 'react-hot-toast'
import { BrowserRouter } from 'react-router-dom'

import { useUser } from './context'
import {
  AppRouter,
  AppRouterProfessor,
  PrivateRoutesAdmin,
  PrivateRoutesStudents,
} from './routes'

import '@fontsource/plus-jakarta-sans'

const App = () => {
  const { userRole } = useUser()

  return (
    <div className="App" style={{ fontFamily: 'Plus Jakarta Sans' }}>
      <Toaster
        position="top-center"
        toastOptions={{
          duration: 3500,
          style: {
            borderRadius: 8,
            fontFamily: 'Plus Jakarta Sans',
            fontSize: 14,
          },
        }}
      />
      <BrowserRouter>
        {userRole === 'admin' && <PrivateRoutesAdmin />}
        {userRole === 'professor' && <AppRouterProfessor />}
        {userRole === 'student' && <PrivateRoutesStudents />}
        {userRole === null && <AppRouter />}
      </BrowserRouter>
    </div>
  )
}

export default App
